import React, { useState, useEffect, useRef } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import HeadingArea from '../../general/HeadingArea';
import axios from 'axios'
import ResponseMsg2 from '../../general/ResponseMsg2';
import { FaPrint } from "react-icons/fa";


const ExamSchedule = ({ setLoading }) => {

  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
    const [response2, setResponse2] = useState({ message: '', status: 'success' });


  //updated
  const [searchTerm, setSearchTerm] = useState('');
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [classes, setClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');

  const [exam, setExam] = useState([]);
    const [std, setStd] = useState([]);
    const printRef = useRef(null);

  const [form, setForm] = useState({
    examType: '',
    class_name: '',
    section: '',
    year: '',
    subject: '',
    examMarks: '',
    total: '',

  })


 
  const fetchExamTypeDetail = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.kcian.in/fetch-exam-type');
      setExam(res.data);

      setLoading(false);
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  };



  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');

      if (response.ok) {
        const data = await response.json();
        setClasses(data);
        setLoading(false);


      } else {
        setLoading(false);
        console.error('Failed to fetch class');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  }


  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

   useEffect(() => {
     if (selectedClassId) {
       const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
       if (selectedClass && selectedClass.sections) {
         const sectionArray = selectedClass.sections
           .split(',')
           .map((s) => s.trim())
           .filter((s) => s !== '');
         setAvailableSections(sectionArray);
       } else {
         setAvailableSections([]);
       }
       setSelectedSection('');
     } else {
       setAvailableSections([]);
       setSelectedSection('');
     }
   }, [selectedClassId, classes]);
 

  useEffect(() => {

    fetchClasses();
    fetchAcademicYears();
    // fetchSubjects();
    fetchExamTypeDetail();

    fetchAcademicYears();

  }, [])


const handleSearch = async (e) => {
  e.preventDefault();

  if (!selectedAY || !selectedClassId || !selectedExam) {
    alert('Please select Academic Year, Class, and Exam Type.');
    return;
  }

  setLoading(true);

  try {

     const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      const className = selectedClass ? selectedClass.class_name : '';
      
       const selectedExamType = exam.find((e) => e.id === Number(selectedExam));
      const examName = selectedExamType ? selectedExamType.exam_name : '';
      

    const params = new URLSearchParams();
    params.append('ay', selectedAY);
    params.append('class_name',className);
    params.append('examType', examName);

    if (selectedSection) {
      params.append('section', selectedSection);
    }

    const url = `https://api.kcian.in/get-exam-schedule?${params.toString()}`;
    console.log('Request URL:', url);
    const response = await axios.get(url);

    const processed = response.data.map(item => ({
  ...item,
  class_name: JSON.parse(item.class_name).className
}));

setStd(processed);
    console.log('Search result:', response.data);

  } catch (error) {
    console.error('Error fetching exam schedule:', error);
  } finally {
    setLoading(false);
  }
};
console.log(std);

 const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'class_name') {
      const selectedClass = classes.find((cls) => cls.id.toString() === value);
      setForm((prev) => ({
        ...prev,
        class_name: selectedClass
          ? { classId: selectedClass.id, className: selectedClass.class_name }
          : '',
      }));
    } else if (name === 'examType') {
      const selectedExam = exam.find((ex) => ex.id.toString() === value);
      setForm((prev) => ({
        ...prev,
        examType: selectedExam
          ? { examTypeId: selectedExam.id, examTypeName: selectedExam.exam_name }
          : '',
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


            const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}-${month}-${year} `;
    };


     const filterExamSchedule = std.filter((tt) => {
        const term = searchTerm.toLowerCase();

        return (
            (tt.sub_name?.toLowerCase() || '').includes(term) ||
            (tt.class_name?.className?.toLowerCase() || '').includes(term) ||
            (tt.total_marks?.toString().toLowerCase() || '').includes(term) ||
            (tt.exam_name?.toString().toLowerCase() || '').includes(term)
        );
    });

  const handlePrint = () => {
    if (!filterExamSchedule.length) {
      setResponse2({ message: 'No Data available to Print', status: 'success' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      return;
    }
    window.print();
  };


  return (
    <>
    <section className="py-4">
       <div className='px-4'>
         <HeadingArea message1="Exam" message2="Exam Schedule" />
                            {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


         <form onSubmit={handleSearch} >
                 <div className="card shadow-sm">
        <div className="card-body">
          <form>

          </form>
          <h5 className="card-title fw-semibold mb-4">Select Criteria</h5>

          <div className="row g-5">


            <div className="col-md-3">
              <div className='profile-input-area mb-3'>
                <label className="profile-badge">Select AY*</label>
                <select
                  className="profile-input"
                   value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                 
                  required
                >
                  <option value="">-- Select Academic Year --</option>
                  {academicYears.map((ay) => (
                    <option key={ay.year} value={ay.year}>
                      {ay.year} --- {ay.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-3">
              <div className='profile-input-area mb-3'>
                <label className="profile-badge">Select Class*</label>
                <select
                  className="profile-input"
                  name='class_name'
                     value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
                
                  required
                >
                  <option value="">-- Select Class --</option>
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>


            {/* ---------- SECTION DROPDOWN ---------- */}
            <div className="col-md-3">
              <div className='profile-input-area mb-3'>
                <label className="profile-badge">Select Section*</label>
                <select
                  className="profile-input"
                  name='section'
                  value={form.section}
                  onChange={handleChange}
                  required
                  disabled={availableSections.length === 0}
                >
                  <option value="">-- Select Section --</option>
                  {availableSections.map((section, idx) => (
                    <option key={idx} value={section}>
                      {section}
                    </option>
                  ))}
                </select>

              </div>
            </div>

            <div className="col-md-3">

              <div className='profile-input-area mb-3'>
                <label className='profile-badge'>Exam Type</label>
                <select
                  className='profile-input'
                  name='examType'
                  value={selectedExam}
                  onChange={(e) => setSelectedExam(e.target.value)}
           
                  required
                >
                  <option value=''>Select Type</option>
                  {exam.map((type, index) => (
                    <option key={type.id} value={type.id}>
                      {type.exam_name}
                    </option>
                  ))}
                </select>

              </div>
              
            </div>
          
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-end mt-4 p-4">
          <button className="profile-btn mt-2" >Search</button>
        </div>


      </div>


         </form>


         <div className='profile-card mt-4'>
          <div className="printable-area" ref={printRef}>
                    <span className="profile-heading">Exam Date Sheet</span>

                    <div className="d-md-flex d-print-none">
                       <button
                                      className="profile-btn2 my-2"
                                      onClick={handlePrint}
                                      disabled={!filterExamSchedule.length}
                                    >
                                      <FaPrint /> Print
                                    </button>
                    <div className='profile-input-area ms-auto col-lg-4 border-0'>
                                    <input
                                        type='text'
                                        name='search'
                                        className='profile-input border-bottom rounded-0'
                                        placeholder='Search by Exam type, Class, Subject'
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
        </div>


                    <div className='table-responsive mt-3'>
                      <table className='w-100 text-center'>
        
                        <thead className='account-thead'>
                          <th className='border'>Exam Date</th>
                                            <th className='border'>Type</th>
                                            <th className='border'>Class</th>
                                            <th className='border'>Subject</th>
                                            <th className='border d-print-none'>Total Mark</th>
                                            {/* <th className='rounded-end-4'>Distribution</th> */}
                    
                        </thead>
        
        
                        {filterExamSchedule.length == 0 ? (
                          <tr className='text-center account-tr'><td colSpan={8}>No Exam Data found</td></tr>
                        ) : (
                          <>
                            {filterExamSchedule.map((exam) => (
                              <tr className='account-tr' key={exam.id}>
                                {/* <td>{exam.year}</td> */}
                                                <td className='border'>{formatDate(exam.exam_date) || '—'}</td>
                                                <td className='border'>{exam.exam_name || '—'}</td>
                                                <td className='border'>{exam.class_name || '—'} ({exam.section})</td>
                                                <td className='border'>{exam.sub_name}</td>
                                                <td className="border d-print-none">{exam.total_marks}</td>
{/* <td className='text-start'>
  {JSON.parse(exam.exam_mark_distribution || '[]').map((e, i) => (
    <div key={i}>
      ● {e.examTitle}: {e.examMark}
    </div>
  ))}
</td> */}
                              </tr>
                            ))}
                          </>
                        )}
        
                      </table>
                    </div>
                    {/* table ends */}
        
        </div>
                  </div>
                  

       </div>
      

     


      
    </section>

      <style>{`
@media print {

  body * {
    visibility: hidden;
  }
  .printable-area, .printable-area * {
    visibility: visible;
  }
  .printable-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    font-size: 0.8em;
  }

  .d-print-none {
    display: none !important;
  }
  .printable-area .row {
    display: flex !important;
    flex-wrap: wrap !important;
  }

}

      `}</style>


</>
  )
}

export default ExamSchedule